import React from "react";

const AppTerms = () => {
  return (
    <div className="min-h-screen bg-[#0e0e0f] py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-[#1B1B1C] rounded-lg shadow-lg overflow-hidden">
        {/* Header */}
        <div className="bg-black text-yellow-400 px-6 py-8">
          <h1 className="text-3xl font-bold text-center mb-2">
            VUPOP USER TERMS
          </h1>
          <p className="text-yellow-300 text-center text-lg">(APP USERS)</p>
        </div>

        <div className="px-6 py-8">
          {/* Summary Section */}
          <div className="mb-8 p-6 bg-[#1B1B1C] rounded-lg border-l-4 border-yellow-400">
            <h2 className="text-xl font-bold text-yellow-400 mb-4 ">SUMMARY</h2>
            <ul className="space-y-3 text-gray-300 ">
              <li className="flex items-start">
                <span className="text-yellow-500 mr-2">•</span>
                <span>
                  VuPop is a platform that lets you upload, share and license
                  Clips.
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-yellow-500 mr-2">•</span>
                <span>
                  VuPop may make your Clips available to Licensees. Licensees
                  don't pay any fees to browse Clips, but if they want to
                  download Clips, copy them, or use them for any other purpose,
                  they will need to enter into the Clip Terms with you and pay a
                  Licence Fee.
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-yellow-500 mr-2">•</span>
                <span>
                  If a Licensee wishes to license a Clip, the transaction will
                  be subject the Clip Terms in force at the time of the
                  transaction. The Clip Terms are a binding contract between you
                  and the Licensee. VuPop is not a party to the Clip Terms.
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-yellow-500 mr-2">•</span>
                <span>
                  You also agree that VuPop can use the Clips you upload. The
                  ways we may use Clips is set out at Clause 3 below.
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-yellow-500 mr-2">•</span>
                <span>
                  We want your Clips to be successful! If we help you to license
                  a Clip to a Licensee, we will collect the relevant fee from
                  the Licensee, keep our Broker's Fee, and you are entitled to
                  the remainder (your 'Royalty'). We make our App available free
                  of charge, but if you want to receive your Royalties, you will
                  need to have an active Premium Membership. Please see Clauses
                  4 and 5 for more details about Royalties and Premium
                  Memberships.
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-yellow-500 mr-2">•</span>
                <span>
                  You are fully responsible for your own Clips. You can only
                  upload Clips that are lawful and where you have (and had) all
                  necessary rights to make the Clips and provide them to us
                  under these Terms.
                </span>
              </li>
              <li className="flex items-start">
                <span className="text-yellow-500 mr-2">•</span>
                <span>
                  If you do not agree with any of these Terms, you should not
                  use our Services.
                </span>
              </li>
            </ul>
          </div>

          {/* Introduction */}
          <div className="mb-8">
            <div className="flex items-center mb-4">
              <div className="w-2 h-8 bg-yellow-400 mr-3"></div>
              <h2 className="text-2xl font-bold text-white">
                Hi, we're <span className="text-yellow-400">VuPop</span>!
              </h2>
            </div>
            <p className="text-gray-300 mb-4">
              Our official name is Social On Air Limited, a company registered
              under the laws of England and Wales (registered number 15140619)
              with our registered office at 11a Abbey Road, Malvern, England,
              WR14 3ES ("<strong>VuPop</strong>", "<strong>we</strong>", "
              <strong>us</strong>" and "<strong>our</strong>"). These terms of
              use ("<strong>Terms</strong>") apply to the use of the Services
              (as defined below). Each individual or organisation wishing to
              make use of the Services ("<strong>you</strong>", the "
              <strong>User</strong>" or "<strong>your</strong>") is subject to
              these Terms, together with any other documents or terms that apply
              to the Services offered and used (together, the "
              <strong>Agreement</strong>").
            </p>

            <div className="bg-[#434345] p-6 rounded-lg border-l-4 border-black mt-6">
              <p className="font-semibold text-gray-300 mb-3">
                By clicking or tapping any button or box marked "accept",
                "agree" or "ok" (or a similar term) referencing these Terms, or
                by signing up to the Services via a website, app or other
                digital channel, you confirm that:
              </p>
              <ul className="space-y-2 text-gray-300">
                <li className="flex items-start">
                  <span className="text-black font-bold mr-2">•</span>
                  <span>you are bound by these Terms;</span>
                </li>
                <li className="flex items-start">
                  <span className="text-black font-bold mr-2">•</span>
                  <span>
                    you are of legal age where you live (18 or over if you live
                    in the UK); and
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="text-black font-bold mr-2">•</span>
                  <span>
                    you have the legal capacity to enter into this Agreement,
                    either as an individual or as an authorised representative
                    of your company.
                  </span>
                </li>
              </ul>
            </div>

            <div className="mt-6 p-4 bg-yellow-100 rounded-lg">
              <p className="text-gray-700">
                <strong>
                  You should print and keep a copy of these Terms for future
                  reference.
                </strong>
              </p>
              <p className="text-gray-700 mt-2">
                <strong>
                  Your attention is drawn in particular to Clause 4.6 and to the
                  warranties, indemnities and limitations of liability in
                  Clauses 11 and 12.
                </strong>
              </p>
            </div>
          </div>

          {/* AGREED TERMS Section */}
          <div className="mb-8">
            <div className="bg-black text-yellow-400 px-4 py-3 rounded-t-lg">
              <h2 className="text-xl font-bold uppercase tracking-wide">
                AGREED TERMS
              </h2>
            </div>

            {/* Clause 1 */}
            <div className="border border-gray-700 rounded-b-lg p-6">
              <h3 className="text-xl font-bold text-white mb-4">
                1. DEFINITION AND INTERPRETATION
              </h3>

              <div className="mb-6 text-gray-300">
                <h4 className="font-semibold text-gray-300 mb-3">
                  1.1 The definitions and rules of interpretation in this Clause
                  apply to these Terms.
                </h4>

                <div className="ml-4 space-y-4">
                  <div>
                    <p>
                      <strong>"App"</strong> means the VuPop mobile app.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Broker's Fee"</strong> has the meaning given at
                      Clause 4.2.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Business Day"</strong> means a day other than a
                      Saturday, Sunday or public holiday in England when banks
                      in London are open for business.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Clip"</strong> means a digital video or image
                      file, with or without accompanying audio content, that has
                      been uploaded via the App.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Clip Terms"</strong> means an agreement between
                      you and any Licensee setting out the terms on which they
                      license a Clip. The version of the Clip Terms in force at
                      the Effective Date can be found at Schedule 1 to these
                      Terms.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Confidential Information"</strong> has the
                      meaning given in Clause 10.1.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Control"</strong> shall be as defined in section
                      1124 of the Corporation Tax Act 2010, and the expression "
                      <strong>change of Control</strong>" shall be construed
                      accordingly.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Data Protection Laws"</strong> mean all
                      applicable laws in relation to data protection, privacy,
                      interception and monitoring of communications, or
                      requirements relating to the processing of personal data
                      of any kind.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Derived Data"</strong> means any documentation,
                      information, reports, data, analysis, files or materials
                      created from or incorporating any User Data.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Dispute"</strong> has the meaning given in Clause
                      16.1.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Dispute Notice"</strong> has the meaning given in
                      Clause 16.1(a).
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Documentation"</strong> means all service
                      descriptions, user manuals, instructions, materials and/or
                      other documents or information provided or otherwise made
                      available to you by VuPop in relation to the Services.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Effective Date"</strong> means the date on which
                      you first accept these Terms or sign up to or use the
                      Services via a website, app or other digital channel,
                      whichever is the earliest.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Force Majeure Event"</strong> has the meaning
                      given in Clause 15.1.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Intellectual Property"</strong> means patents,
                      utility models, rights to inventions, copyright and
                      related rights, trade marks and service marks, rights in
                      and to trade names and domain names, rights in get-up,
                      goodwill and the right to sue for passing off or unfair
                      competition, rights in designs, rights in computer
                      products, database rights, rights to preserve the
                      confidentiality of information (including know-how and
                      trade secrets) and any other intellectual property rights,
                      including all applications for (and rights to apply for
                      and be granted), renewals or extensions of, and rights to
                      claim priority from, such rights and all similar or
                      equivalent rights or forms of protection which subsist or
                      will subsist, now or in the future, in any part of the
                      world.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Licensee"</strong> means any third party that has
                      agreed to the Licensee Terms.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Licensee Terms"</strong> means the terms and
                      conditions at <a>https://vupop.io/legal/licensee-terms</a>
                      .
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Licence Fee"</strong> means the fee paid by a
                      Licensee to license a Clip under the Clip Terms.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Membership Fee"</strong> means the fees that you
                      agree to pay VuPop if you sign up for Premium Membership.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Normal Business Hours"</strong> mean 9.00 am to
                      5.00 pm UK time, each Business Day.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Party"</strong> or "<strong>party</strong>" means
                      VuPop or the User (and "<strong>parties</strong>" shall be
                      construed accordingly).
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Payout Tracker"</strong> means the App
                      functionality that shows the history of your payouts
                      throughout your use of the App.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Personnel"</strong> means a Party's directors,
                      officers, partners, principals, employees, agents,
                      auditors, consultants, representatives, advisers and
                      subcontractors.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Premium Membership"</strong> means a paid monthly
                      subscription that enables a User to access the Premium
                      Services.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Premium Services"</strong> has the meaning given
                      in Clause 5.1.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Quality Rules"</strong> means any rules about the
                      quality or content of Clips that are notified to you from
                      time to time.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Royalty"</strong> has the meaning given in Clause
                      4.2 and "<strong>Royalties</strong>" shall be construed
                      accordingly.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Services"</strong> means any software, content,
                      materials or services made available via the App, now or
                      in the future, and the Documentation. The Services under
                      these Terms{" "}
                      <span className="underline">do not include</span> use of
                      or access to the Vault, which are always subject to the
                      Licensee Terms [Hyperlink].
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Term"</strong> means the term of this Agreement.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"User Data"</strong> means, together: (a) any
                      data, information or materials inputted to the Services by
                      or on behalf of the User, including the Clips; (b) any
                      information about how you interact with the Services; and
                      (c) any metadata relating to any of the foregoing.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"User Default"</strong> has the meaning given at
                      Clause 7.3.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Virus"</strong> means any thing or device
                      (including any software, code, file or programme) which
                      may: prevent, impair or otherwise adversely affect the
                      operation of any computer software, hardware or network,
                      any telecommunications service, equipment or network or
                      any other service or device; prevent, impair or otherwise
                      adversely affect access to or the operation of any
                      programme or data, including the reliability of any
                      programme or data (whether by re-arranging, altering or
                      erasing the programme or data in whole or part or
                      otherwise); or adversely affect the user experience,
                      including worms, trojan horses, viruses and other similar
                      things or devices.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Vulnerability"</strong> means a weakness in the
                      computational logic (for example, code) found in software
                      and hardware components that when exploited, results in a
                      negative impact to the confidentiality, integrity, or
                      availability, and the term "
                      <strong>Vulnerabilities</strong>" shall be interpreted
                      accordingly.
                    </p>
                  </div>
                  <div>
                    <p>
                      <strong>"Vault"</strong> means the software, content
                      and/or services made available at{" "}
                      <a
                        href="http://www.vupop.io"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline text-yellow-400 hover:text-yellow-300"
                      >
                        www.vupop.io
                      </a>
                      , now or in the future, to people who have signed up to
                      the Licensee Terms.
                    </p>
                  </div>
                </div>
              </div>

              <div className="ml-4 space-y-4 text-gray-300">
                <div>
                  <p>
                    <strong>1.2</strong> Clause, schedule and paragraph headings
                    are for convenience only and do not affect the
                    interpretation of this Agreement.
                  </p>
                </div>
                <div>
                  <p>
                    <strong>1.3</strong> References to Clauses and Schedules are
                    to the clauses and schedules of these Terms.
                  </p>
                </div>
                <div>
                  <p>
                    <strong>1.4</strong> A person includes an individual,
                    corporate or unincorporated body (whether or not having
                    separate legal personality) and that person's legal and
                    personal representatives, successors or permitted assigns.
                  </p>
                </div>
                <div>
                  <p>
                    <strong>1.5</strong> A reference to a company shall include
                    any company, corporation or other body corporate, wherever
                    and however incorporated or established.
                  </p>
                </div>
                <div>
                  <p>
                    <strong>1.6</strong> Unless the context otherwise requires,
                    words in the singular shall include the plural and in the
                    plural shall include the singular, and a reference to one
                    gender (or none) shall include a reference to the other
                    genders (or none).
                  </p>
                </div>
                <div>
                  <p>
                    <strong>1.7</strong> A reference to a statute or statutory
                    provision is a reference to such legislation as amended,
                    modified or re-enacted from time to time and shall include
                    all subordinate legislation made under that statute or
                    statutory provision (as amended, modified or re-enacted from
                    time to time).
                  </p>
                </div>
                <div>
                  <p>
                    <strong>1.8</strong> Any words following the terms{" "}
                    <strong>including</strong>, <strong>include</strong>,{" "}
                    <strong>in particular</strong>, <strong>for example</strong>{" "}
                    or any similar expression shall be construed as illustrative
                    and shall not limit the sense of the words, description,
                    definition, phrase or term preceding those terms. Any
                    reference to writing includes email.
                  </p>
                </div>
                <div>
                  <p>
                    <strong>1.9</strong> Any obligation on a Party not to do
                    something includes an obligation not to allow that thing to
                    be done.
                  </p>
                </div>
                <div>
                  <p>
                    <strong>1.10</strong> A reference to 'writing' or 'written'
                    includes email but not fax.
                  </p>
                </div>
              </div>
            </div>

            {/* Clause 2 */}
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">2. LICENCE</h3>

              <div className="space-y-6 text-gray-300">
                <div>
                  <p>
                    <strong>2.1</strong> VuPop hereby grants you a licence to use the Services
                    during the Term in accordance with this Agreement. This
                    licence is non-exclusive, non-transferable, and
                    non-sub-licensable.
                  </p>
                </div>

                <div>
                  <p>
                   <strong>2.2</strong>These Terms apply only to our App, which allows you to
                    upload Clips. If you want to download and use Clips from
                    other users, you should sign up as a{" "}
                    <a
                      href="https://vupop.io/legal/licensee-terms"
                      target="_blank"
                        rel="noopener noreferrer"
                      className="text-yellow-600 underline hover:text-yellow-500"
                    >
                      Licensee
                    </a>
                    . You can sign up as a User under these Terms and as a
                    Licensee, but the accounts will be separate.
                  </p>
                </div>
              </div>
            </div>

            {/* Clause 3 */}
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                3. CLIPS AND CLIP TERMS
              </h3>

              <div className="space-y-6 text-gray-300">
                <div>
                  <p className="mb-4">
                    <strong>3.1</strong> We help you to monetise your Clips by making them
                    available to Licensees. You agree that VuPop may make Clips
                    available to Licensees:
                  </p>
                  <ul className="ml-6 list-disc space-y-2">
                    <li>to browse free of charge; and</li>
                    <li>
                      to license pursuant to the Clip Terms. Any licensing under
                      the Clip Terms will earn you a Royalty (see Clause 4
                      below).
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                   <strong>3.2</strong>You also agree that VuPop may use Clips to promote
                    VuPop’s own products and services.
                  </p>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>3.3</strong> You acknowledge, agree and understand that:
                  </p>
                  <ul className="ml-6 space-y-2 list-none">
                    <li>
                      (a) By agreeing to these Terms, you are agreeing to enter
                      into the Clip Terms with any Licensee who wishes to
                      license a Clip, whether during or after the Term.
                    </li>
                    <li>
                      (b) The Clip Terms will be a binding contract between you
                      and any Licensee who licenses a Clip. Please read them
                      carefully and check that you agree with all of their terms
                      before you accept these Terms.
                    </li>
                    <li>
                      (c) The Clip Terms may be updated from time to time, and
                      we will notify you of any updates as long as you maintain
                      an active account with us. Each transaction with a
                      Licensee will be subject to the most current version of
                      the Clip Terms at the relevant time.
                    </li>
                    <li>
                      (d) Any amendments to the Clip Terms will not affect any
                      agreement between you and a Licensee that existed before
                      the changes came into effect.
                    </li>
                    <li>
                      (e) VuPop helps to facilitate the transaction between you
                      and the Licensee, but VuPop is not a party to the Clip
                      Terms. If you have any dispute with a Licensee, you will
                      need to engage directly with them to resolve it. This can
                      be done by raising an issue in the App.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Clause 4 */}
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                4. LICENCE FEES AND ROYALTIES
              </h3>

              <div className="space-y-6 text-gray-300">
                <div>
                  <p>
                    <strong>4.1</strong> Licensees need to pay a Licence Fee to license a Clip
                    under the Clip Terms. We will use commercially reasonable
                    efforts to achieve what we consider to be a fair market
                    price for any Clip.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>4.2</strong> The Licence Fee is paid by the Licensee to VuPop. Of the
                    Licence Fee we receive, we generally keep between 30–55%,
                    which may vary depending on the Licensee (our “Broker’s
                    Fee”). Subject to Clauses 4.3 and 4.9, we aim to pay the
                    remainder (your “Royalty”) to you immediately, but this can
                    take up to sixty (60) days.
                  </p>
                </div>

                <div>
                  <p className="mb-4"><strong>4.3</strong> We may:</p>
                  <ul className="ml-6 list-disc space-y-2">
                    <li>
                      (a) delay or suspend a payout of your Royalties if we
                      suspect fraudulent activity connected with your account;
                      and/or
                    </li>
                    <li>
                      (b) withhold payment of your Royalties if we reasonably
                      consider that the relevant Clip, or your provision of the
                      Clip, was in breach of this Agreement.
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>4.4</strong> Any Royalties will be paid to you in the currency of
                    your linked bank account. If this is in a currency other
                    than GBP, you will receive the Royalties less any applicable
                    transfer or exchange fees incurred by VuPop.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>4.5</strong> You are responsible for ensuring that any bank account
                    or payment details you provide are correct. You acknowledge
                    that VuPop is not responsible for any Royalties that you do
                    not receive due to incorrect details given or a failure to
                    provide valid bank details within the timescale required by
                    Clause 4.6(b).
                  </p>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>4.6</strong> We make our App available free of charge, but if you
                    want to receive Royalties, you will need to:
                  </p>
                  <ul className="ml-6  space-y-2 list-none">
                    <li>
                      (a) have an active Premium Membership at the time we make
                      the payment (see Clause 4.2 above and Clause 5 below); and
                    </li>
                    <li>
                      (b) ensure that you provide valid and correct bank details
                      within ninety (90) days of being asked to do so. If you
                      fail to provide or confirm correct bank details within
                      this time period, you will lose your right to receive the
                      payout due to you. This does not affect future payouts
                      provided that correct bank details are provided.
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>4.7</strong> If a Licensee licenses one of your Clips under the Clip
                    Terms, you will get a notification of the transaction
                    telling you how much of a Clip they have decided to license.
                    Your Royalty will be visible in the Payout Tracker once you
                    have been paid.
                  </p>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>4.8</strong> We really want your Clips to be successful, but you
                    acknowledge and agree that we cannot guarantee:
                  </p>
                  <ul className="ml-6 list-disc space-y-2">
                    <li>(a) that any Licensee will license your Clips; or</li>
                    <li>(b) any minimum Licence Fee or Royalty amounts.</li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>4.9</strong> You also acknowledge and agree that you will only be
                    able to accrue Royalties for as long as you maintain the App
                    account that was associated with the Clip upload. If you
                    delete or deactivate your account, you will cease to accrue
                    Royalties, but the Clip will still be available for
                    Licensees to license under the latest Clip Terms. We
                    therefore recommend that you keep your App account active
                    and with up-to-date bank details (even if you are not using
                    it) so you can continue to accrue and receive Royalties.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>4.10</strong> You agree that VuPop is not responsible for any tax
                    liabilities or reporting obligations that might apply to you
                    because of your activities using the Services and/or your
                    receipt of any Royalties.
                  </p>
                </div>
              </div>
            </div>

            {/* Clause 5 */}
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                5. PREMIUM MEMBERSHIP
              </h3>

              <div className="space-y-6 text-gray-300">
                <div>
                  <p>
                    <strong>5.1</strong> Some of our Services – including the ability to receive
                    Royalties – are reserved for Premium Members. You can read
                    about the benefits of Premium Membership (our “Premium
                    Services”){" "}
                   <a
                      href="https://vupop.io/premium"
                      target="_blank"
                        rel="noopener noreferrer"
                      className="text-yellow-600 underline hover:text-yellow-500"
                    >
                      here
                    </a>
                    .
                  </p>
                </div>

                <div>
                  <p>
                   <strong>5.2</strong> We reserve the right to vary the Premium Services from
                    time to time.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>5.3</strong> If you subscribe to a Premium Membership, you may access
                    that Premium Membership as soon as payment details have been
                    successfully submitted to the relevant app store.
                  </p>
                </div>

                <div>
                  <p className="mb-4">
                   <strong>5.4</strong> Premium Membership is a subscription that continues
                    indefinitely until cancelled. You understand and agree that
                    you will be charged the Membership Fee:
                  </p>
                  <ul className="ml-6  space-y-2 list-none">
                    <li>
                      (a) on the day you subscribe for Premium Membership; and
                    </li>
                    <li>(b) thereafter on a monthly basis.</li>
                  </ul>
                </div>

                <div>
                  <p>
                   <strong>5.5</strong> Payment for the Membership Fee will be taken via your
                    chosen payment method by the relevant app store.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>5.6</strong> You may cancel your Premium Membership through the
                    relevant app store. Cancellation will take effect at the end
                    of the billing period in which you cancel. You must cancel
                    at least twenty-four (24) hours before your next payment is
                    due to give the app store enough time to register the
                    cancellation.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>5.7</strong> We may withdraw or suspend a Premium Membership, in
                    whole or in part, at any time and for any reason, in which
                    case VuPop shall not be obligated to maintain or permit any
                    further access to such Premium Membership and the Membership
                    Fee will no longer be charged. Our decision whether or not
                    to suspend or cancel a Premium Membership under this Clause
                    5.7 is independent of and separate to our general right to
                    suspend or cancel the Services under Clause 13.2.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>5.8</strong> Membership Fees are not refundable. This does not impact
                    your statutory rights.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>5.9</strong>We may also run offers or promotions in respect of our
                    Premium Membership and/or Premium Services from time to
                    time. If you have subscribed to Premium Membership under the
                    terms of a specific offer or promotion (“Promotional
                    T&amp;Cs”), then, to the extent of any inconsistency or
                    conflict between this Agreement and the Promotional
                    T&amp;Cs, the Promotional T&amp;Cs will take priority for
                    the duration of the relevant offer or promotion. Once the
                    relevant offer or promotion has expired or is terminated,
                    these Terms will apply in full, and you authorise the
                    relevant app store to begin charging your chosen payment
                    method in accordance with this Clause 5.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>5.10</strong> You acknowledge that prices for the Premium Membership
                    may change from time to time. We do not provide price
                    protection or refunds in the event of a price reduction or
                    promotional offering. Any changes to pricing for Premium
                    Memberships with recurring payments, excluding pricing
                    changes due to changes in applicable taxes, will only apply
                    following reasonable notice to you. If we notify you of a
                    price change for a Premium Membership with a recurring
                    payment and you do not want to continue at the new price,
                    you can cancel your Premium Membership in accordance with
                    Clause 5.6.
                  </p>
                </div>
              </div>
            </div>

            {/* Clause 6 */}
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                6. USER OBLIGATIONS AND RESTRICTIONS
              </h3>

              <div className="space-y-6 text-gray-300">
                <div>
                  <p className="mb-4"><strong>6.1</strong>You agree that you will:</p>
                  <ul className="ml-6  space-y-2 list-none">
                    <li>
                      (a) comply with all applicable laws and regulations with
                      respect to your activities under this Agreement. This
                      obligation is in addition to your other obligations under
                      this Agreement;
                    </li>
                    <li>
                      (b) carry out all your responsibilities under this
                      Agreement in a timely and efficient manner, and in any
                      event in accordance with any reasonable deadlines
                      specified by VuPop from time to time;
                    </li>
                    <li>
                      (c) be responsible for the legality, reliability,
                      integrity, accuracy and quality of all User Data; and
                    </li>
                    <li>
                      (d) be, to the extent permitted by law and except as
                      otherwise expressly provided in this Agreement, solely
                      responsible for procuring, maintaining and securing your
                      network connections and telecommunications links from your
                      systems to VuPop’s data centres, and for all problems,
                      conditions, delays, delivery failures and all other loss
                      or damage arising from or relating to your network
                      connections or telecommunications links or caused by the
                      internet.
                    </li>
                  </ul>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>6.2</strong> You shall not access, store, upload, distribute or
                    transmit any Viruses, or any material (including any User
                    Data) during your use of the Services that:
                  </p>
                  <ul className="ml-6 list-disc space-y-2 list-none">
                    <li>
                      (a) is unlawful, harmful, threatening, defamatory,
                      obscene, infringing, harassing or racially or ethnically
                      offensive;
                    </li>
                    <li>(b) facilitates illegal activity;</li>
                    <li>(c) depicts sexually explicit images;</li>
                    <li>(d) promotes unlawful violence;</li>
                    <li>
                      (e) is discriminatory based on race, gender, colour,
                      religious belief, sexual orientation, disability;
                    </li>
                    <li>
                      (f) infringes any third party rights (including
                      Intellectual Property rights, contractual rights and
                      rights to privacy);
                    </li>
                    <li>
                      (g) was recorded or created in an unlawful manner; or
                    </li>
                    <li>
                      (h) is otherwise illegal or causes damage or injury to any
                      person or property.
                    </li>
                  </ul>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>6.3</strong> In addition to the provisions of Clause 6.2, you agree
                    that any Clips you upload:
                  </p>
                  <ul className="ml-6 space-y-2 list-none">
                    <li>
                      (a) are a true, contemporaneous record of an actual event;
                    </li>
                    <li>
                      (b) have not been edited in any manner (including by the
                      addition of any filters, text, or the use of AI);
                    </li>
                    <li>
                      (c) have not been uploaded on any other platform, or dealt
                      with in any way that conflicts with the Clip Terms (and
                      you agree that you will not do so);
                    </li>
                    <li>
                      (d) have not been copied or re-posted from any other
                      sources; and
                    </li>
                    <li>(e) comply with VuPop’s Quality Rules.</li>
                  </ul>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>6.4</strong> You agree that you will immediately notify VuPop if you
                    have reason to believe that:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) any User Data may be in breach (or have become in
                      breach) of Clause 6.2 or 6.3 above; or
                    </li>
                    <li>
                      (b) the App is being used for unlawful purposes (including
                      fraud).
                    </li>
                  </ul>
                </div>

                <div>
                  <p className="mb-4"><strong>6.5</strong> You shall not:</p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) except as may be permitted by this Agreement, by any
                      applicable Clip Terms, or by any mandatory provision of
                      applicable law:
                      <ul className="ml-8 list-none space-y-1">
                        <li>
                          (i) attempt to copy, modify, duplicate, create
                          derivative works from, frame, mirror, republish,
                          download, display, transmit, or distribute all or any
                          portion of the Services in any form or media or by any
                          means; or
                        </li>
                        <li>
                          (ii) attempt to de-compile, reverse compile,
                          disassemble, reverse engineer or otherwise reduce to
                          human-perceivable form all or any part of the
                          Services;
                        </li>
                      </ul>
                    </li>
                    <li>
                      (b) access all or any part of the Services in order to
                      build a product or service which competes with the
                      Services;
                    </li>
                    <li>
                      (c) license, sell, rent, lease, transfer, assign,
                      distribute, display, disclose, or otherwise commercially
                      exploit, or otherwise make the Services available to any
                      third party;
                    </li>
                    <li>
                      (d) use the Services in a manner that VuPop determines, in
                      its sole discretion, to be excessive;
                    </li>
                    <li>
                      (e) attempt to obtain, or assist third parties in
                      obtaining, unauthorised access to the Services; or
                    </li>
                    <li>
                      (f) introduce or permit the introduction of any Virus or
                      Vulnerability into the Services or VuPop’s network or
                      information systems.
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>6.6</strong> You shall keep your account and log-in details secure
                    and shall not allow them to be used by any other person. If
                    you have reason to believe that your account details have
                    been accessed or used by anybody else, you shall notify
                    VuPop and reset your password immediately.
                  </p>
                </div>

                <div>
                  <p>
                    6.7 You shall not during or for one year after the Term of
                    this Agreement approach any Licensees or their Personnel
                    direct with a view to completing any transaction outside of
                    the Services.
                  </p>
                </div>
              </div>
            </div>

            {/* Clause 7 */}
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                7. VUPOP’S PROVISION OF THE SERVICES
              </h3>

              <div className="space-y-6 text-gray-300">
                <div>
                  <p className="mb-4"><strong>7.1</strong> You acknowledge and agree that:</p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) VuPop does not warrant that:
                      <ul className="ml-8 list-none space-y-1">
                        <li>(i) the Services will always be available;</li>
                        <li>
                          (ii) the Services will be uninterrupted or error-free;
                        </li>
                        <li>
                          (iii) the Services will meet the User’s requirements;
                          or
                        </li>
                        <li>
                          (iv) the Services will be free from Vulnerabilities or
                          Viruses;
                        </li>
                      </ul>
                    </li>
                    <li>
                      (b) VuPop is not responsible for any delays, delivery
                      failures, or any other loss or damage resulting from the
                      transfer of data over communications networks and
                      facilities, including the internet, and you acknowledge
                      that the Services may be subject to limitations, delays
                      and other problems inherent in the use of such
                      communications facilities.
                    </li>
                  </ul>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>7.2</strong> VuPop reserves the right to remove any User Data for any
                    reason without any liability to you. This includes, for
                    example, if we consider in our sole discretion that any User
                    Data:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>(a) may breach Clause 6.2 or 6.3; or</li>
                    <li>
                      (b) may be detrimental to VuPop’s reputation or
                      operations.
                    </li>
                  </ul>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>7.3</strong> If VuPop’s performance of any of its obligations under
                    this Agreement is prevented or delayed by any act by or
                    omission of you or your Personnel, or by any failure or
                    delay by you or your Personnel to perform any relevant
                    obligation (“User Default”):
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) VuPop shall not be liable for:
                      <ul className="ml-8 list-none space-y-1">
                        <li>
                          (i) VuPop’s non-performance or delay (to the extent it
                          was caused by the User Default); or
                        </li>
                        <li>
                          (ii) any costs or losses sustained or incurred by you
                          arising directly or indirectly from your User Default;
                          and
                        </li>
                      </ul>
                    </li>
                    <li>
                      (b) you shall reimburse VuPop on written demand for any
                      and all costs or losses sustained or incurred by VuPop
                      arising directly or indirectly from any User Default.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Clause 8 */}
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                8. DATA PROTECTION
              </h3>

              <div className="space-y-6 text-gray-300">
                <div>
                  <p>
                    <strong>8.1</strong> For the purposes of this Agreement the words and
                    phrases, “personal data”, “controller” and “data subjects”
                    shall have the meanings given in the Data Protection Laws.
                  </p>
                </div>

                <div>
                  <p>
                   <strong>8.2</strong> It is the Parties’ intention and understanding that
                    VuPop is a controller of any personal data provided by the
                    User to VuPop.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>8.3</strong> The Parties shall comply with the Data Protection Laws
                    in relation to this Agreement. In particular, the User
                    agrees that it will only upload personal data to the App
                    (including any personal data in any Clips) where it has all
                    necessary rights to do so, and where it has given all
                    necessary notices to any relevant data subjects. This Clause
                    8.3 is in addition to, and does not relieve, remove or
                    replace, either Party’s obligations or rights under the Data
                    Protection Laws.
                  </p>
                </div>
              </div>
            </div>

            {/* Clause 9 */}
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                9. INTELLECTUAL PROPERTY RIGHTS
              </h3>

              <div className="space-y-6 text-gray-300">
                <div>
                  <p className="mb-4">
                    <strong>9.1</strong>You hereby grant VuPop a fully paid-up, non-exclusive,
                    royalty-free, worldwide, perpetual, irrevocable,
                    transferable licence to:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) use Clips in accordance with Clauses 3.1 and 3.2
                      above;
                    </li>
                    <li>
                      (b) use any User Data for any purpose (including the
                      creation of Derived Data); and
                    </li>
                    <li>
                      (c) use or incorporate any feedback you provide into our
                      products and/or services.
                    </li>
                  </ul>
                  <p className="mt-4">
                    If VuPop uses a Clip for our own promotional purposes under
                    Clause 3.2, we may (but are not required to) pay you a fee.
                    If we choose to do so, the fee paid by VuPop will be treated
                    in the same manner as any other Royalty.
                  </p>
                </div>

                <div>
                  <p className="mb-4">
                   <strong>9.2</strong> The Parties acknowledge and agree that:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) VuPop and/or its licensors own all Intellectual
                      Property rights in the Services, and except as expressly
                      stated herein, this Agreement does not grant you any
                      rights to, under or in the Services or any Intellectual
                      Property rights therein; and
                    </li>
                    <li>
                      (b) subject to any applicable Clip Terms, all Intellectual
                      Property rights in any Clip are owned by the User who
                      uploaded the Clip (or their licensors).
                    </li>
                  </ul>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>9.3</strong> You acknowledge and agree that, subject to Clause
                    9.2(b), VuPop will own all new Intellectual Property rights
                    created by VuPop or on VuPop’s behalf:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>(a) in any Derived Data; and</li>
                    <li>(b) in VuPop’s performance of the Services.</li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>9.4</strong> You shall not use any trade mark, copyright, branding
                    elements, or other Intellectual Property rights of VuPop
                    without VuPop’s prior written consent, unless you are
                    entitled to do so under applicable law.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>9.5</strong> All rights not expressly granted by this Agreement are
                    reserved.
                  </p>
                </div>
              </div>
            </div>

            {/* Clause 10 */}
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                10. CONFIDENTIALITY
              </h3>

              <div className="space-y-6 text-gray-300">
                <div>
                  <p className="mb-4">
                    <strong>10.1</strong> Subject to Clause 10.2, the User will hold all
                    Confidential Information in the strictest confidence.
                    “Confidential Information” means anything provided by or on
                    behalf of VuPop that is marked as confidential, is notified
                    to the User as being confidential or that could reasonably
                    be considered to be confidential. The parties agree that
                    Confidential Information includes any information relating
                    to VuPop’s business, affairs, strategies, suppliers,
                    Personnel, software, operations, processes, prices and
                    pricing models, Broker’s Fees, products, services,
                    Intellectual Property, and any personal data accessed and/or
                    processed by the User’s Personnel.
                  </p>
                </div>

                <div>
                  <p className="mb-4">
                   <strong>10.2</strong> The confidentiality obligations in Clause 10.1 shall
                    not apply to:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) any disclosures that the User is required to make by
                      law, by a court of competent jurisdiction, or by any
                      regulatory body, but only to the minimum extent required,
                      and provided that the User first notifies VuPop of the
                      requirement (if not prohibited by applicable law) and,
                      upon the request of VuPop, the User shall use commercially
                      reasonable efforts to assist VuPop, at VuPop’s sole
                      expense, in seeking an appropriate protective order;
                    </li>
                    <li>
                      (b) information that has come into the public domain
                      through no fault of the User;
                    </li>
                    <li>
                      (c) information that the User develops independently
                      (without the benefit of the Confidential Information) or
                      receives from a third party (which is not in breach of a
                      continuing obligation of confidentiality to VuPop); and
                    </li>
                    <li>
                      (d) the User’s right to share the Confidential Information
                      with its Personnel, who will each be informed of the
                      confidential nature of the Confidential Information and
                      instructed to treat such information confidentially and
                      the User shall be liable to VuPop if any such Party should
                      fail to comply with the terms of such confidentiality
                      obligation.
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>10.3</strong> You shall not use any Confidential Information for any
                    purpose other than to perform your obligations and exercise
                    your rights under this Agreement.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>10.4</strong> Neither Party shall make, or permit any person to make,
                    any public announcement concerning this Agreement without
                    the prior written consent of the other Party (such consent
                    not to be unreasonably withheld or delayed), except as
                    required by law, any governmental or regulatory authority
                    (including, without limitation, any relevant securities
                    exchange), any court or other authority of competent
                    jurisdiction.
                  </p>
                </div>
              </div>
            </div>

            {/* Clause 11 */}
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                11. WARRANTIES AND INDEMNITIES
              </h3>

              <div className="space-y-6 text-gray-300">
                <div>
                  <p>
                    <strong>11.1</strong> Each Party warrants to the other that it has the full
                    power, capacity and authority to enter into this Agreement
                    and to perform its obligations under this Agreement.
                  </p>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>11.2</strong> You hereby warrant, represent and undertake that:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) you shall obtain and shall maintain all necessary
                      licences, consents, permissions, notices and provisions
                      for:
                      <ul className="ml-8 list-none space-y-1">
                        <li>(i) you to provide the User Data to VuPop;</li>
                        <li>
                          (ii) VuPop, its contractors and agents to use the User
                          Data in accordance with this Agreement; and
                        </li>
                        <li>
                          (iii) any Licensee to use any Clips in accordance with
                          the applicable Clip Terms;
                        </li>
                      </ul>
                    </li>
                    <li>
                      (b) no User Data is (and shall not be at any time) in
                      breach of Clause 6.2 or 6.3;
                    </li>
                    <li>
                      (c) your receipt and use of the Services shall be for
                      legitimate business purposes and in compliance with all
                      applicable laws and regulations; and
                    </li>
                    <li>
                      (d) without prejudice to any other provision of these
                      Terms, the receipt and use of the User Data in the
                      performance of this Agreement by VuPop and its Personnel
                      does not, and shall not, infringe the rights, including
                      any Intellectual Property rights, of any third party.
                    </li>
                  </ul>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>11.3</strong> You will hold VuPop harmless from, and indemnify VuPop
                    on demand and keep VuPop fully and effectively indemnified
                    from and against, all costs, expenses, damages and losses,
                    including any interest, fines, legal and other professional
                    fees and expenses awarded against or incurred or paid by
                    VuPop, and any sums agreed to in settlement, as a result of,
                    or in connection with:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) your actual or alleged breach of Clause 10.1 or Clause
                      11.2 above;
                    </li>
                    <li>
                      (b) VuPop’s use of the Clips in accordance with this
                      Agreement;
                    </li>
                    <li>(c) any use of the Clips by any Licensor; and</li>
                    <li>
                      (d) any Clip Terms you have (or are alleged to have, or
                      purport to have) entered into.
                    </li>
                  </ul>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>11.4</strong> If any third party makes a claim, or notifies VuPop
                    that it is intending to make a claim, against VuPop, which
                    may reasonably be considered to be likely to give rise to a
                    liability under an indemnity given under Clause 11.3 of this
                    Agreement, VuPop will give you written notice of such claim
                    and allow you to have sole authority to dispute, compromise
                    or defend such claim with the assistance of VuPop as
                    reasonably requested by you (and you agree to reimburse
                    VuPop in full for all such assistance).
                  </p>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>11.5</strong> Except as expressly and specifically provided in this
                    Agreement:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) you assume sole responsibility for your use of the
                      Services, and for any reliance placed on such use;
                    </li>
                    <li>
                      (b) VuPop shall have no liability for:
                      <ul className="ml-8 list-none space-y-1">
                        <li>
                          (i) any Clips you provide, or any ways a Licensor uses
                          (or is alleged to have used) such Clips;
                        </li>
                        <li>
                          (ii) any disputes in relation to the Clip Terms;
                        </li>
                        <li>
                          (iii) any loss or damage caused by errors, faults or
                          omissions in any User Data you provide to VuPop and/or
                          any Licensees in connection with the Services;
                        </li>
                        <li>
                          (iv) any use of the Services in breach of this
                          Agreement or contrary to VuPop’s instructions from
                          time to time;
                        </li>
                        <li>
                          (v) modification or alteration of the Services by any
                          party other than VuPop or VuPop’s duly authorised
                          contractors or agents; or
                        </li>
                        <li>
                          (vi) any actions taken by VuPop at your direction;
                        </li>
                      </ul>
                    </li>
                    <li>
                      (c) all warranties, representations, conditions and all
                      other terms of any kind whatsoever implied by statute or
                      common law are, to the fullest extent permitted by
                      applicable law, excluded from this Agreement; and
                    </li>
                    <li>
                      (d) the Services and the Documentation are provided to you
                      on an “as is” and “as available” basis.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Clause 12 */}
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                12. LIMITATION OF LIABILITY
              </h3>

              <div className="space-y-6 text-gray-300">
                <div>
                  <p className="mb-4">
                    <strong>12.1</strong> Subject to Clauses 12.2 and 12.3, in any calendar year,
                    VuPop’s total aggregate liability in contract, tort
                    (including negligence or breach of statutory duty),
                    misrepresentation, restitution or otherwise, arising in
                    connection with the performance or contemplated performance
                    of this Agreement shall be limited to:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) if you have ever held Premium Membership: the total
                      Membership Fees paid by you or half of the Royalties
                      received by you during that calendar year, whichever is
                      the greater; or
                    </li>
                    <li>
                      (b) if you have never held Premium Membership: £1 (one
                      pound sterling).
                    </li>
                  </ul>
                  <p className="mt-4">
                    We provide our general services free of charge, so you
                    understand and agree that VuPop would be unable to do so
                    without this limitation of liability.
                  </p>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>12.2</strong> Nothing in this Agreement excludes the liability of
                    either Party:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) for death or personal injury caused by its negligence;
                    </li>
                    <li>(b) for fraud or fraudulent misrepresentation; or</li>
                    <li>
                      (c) for any other liability which cannot be excluded or
                      restricted under applicable law.
                    </li>
                  </ul>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>12.3</strong> Subject to Clause 12.2, VuPop shall not be liable
                    whether in tort (including for negligence or breach of
                    statutory duty), contract, misrepresentation, restitution or
                    otherwise for any:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) loss of profits, loss of business, wasted expenditure,
                      depletion of goodwill and/or similar losses;
                    </li>
                    <li>(b) loss or corruption of data or information;</li>
                    <li>(c) pure economic loss; or</li>
                    <li>
                      (d) any special, indirect or consequential loss, costs,
                      damages, charges or expenses,
                    </li>
                  </ul>
                  <p className="mt-4">
                    howsoever arising under this Agreement.
                  </p>
                </div>
              </div>
            </div>

            {/* Clause 13 */}
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                13. TERM AND TERMINATION
              </h3>

              <div className="space-y-6 text-gray-300">
                <div>
                  <p>
                    <strong>13.1</strong> This Agreement shall commence on the Effective Date and
                    shall continue until terminated in accordance with this
                    Clause 13.
                  </p>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>13.2</strong> VuPop may terminate this Agreement and/or suspend the
                    supply of all or part of the Services with immediate effect
                    by giving notice to you for any reason, including if:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) you breach this Agreement, or we have reasonable
                      grounds to believe you have done so;
                    </li>
                    <li>
                      (b) you fail to pay any amount due under this Agreement on
                      the due date for payment; or
                    </li>
                    <li>
                      (c) you are a company and undergo a change of Control.
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>13.3</strong> You can terminate this Agreement at any time by
                    deactivating your account, however, this will affect your
                    ability to receive Royalties. Please see Clause 4.6 for more
                    details.
                  </p>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>13.4</strong> On termination of this Agreement for any reason:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) all licences granted to you under this Agreement shall
                      immediately terminate;
                    </li>
                    <li>
                      (b) you shall immediately cease all use of the Services
                      and the Documentation;
                    </li>
                    <li>
                      (c) you will cease to accrue any further Royalties, as set
                      out at Clause 4.9; and
                    </li>
                    <li>
                      (d) any rights, remedies, obligations or liabilities of
                      the Parties that have accrued up to the date of
                      termination, including the right to claim damages in
                      respect of any breach of the Agreement which existed at or
                      before the date of termination shall not be affected or
                      prejudiced.
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>13.5</strong> As set out at Clause 4.6, you must have an active
                    Premium Membership to receive a Royalty. We do not recommend
                    terminating this Agreement if you have accrued (but have not
                    yet been paid) any Royalties, as you will lose the right to
                    receive them.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>13.6</strong> Any provision of this Agreement which expressly, or by
                    implication, is intended to come into or continue in effect
                    on or after termination or expiry (including, without
                    limitation, Clauses 1, 3, 4.6, 4.9, 6.1(c), 6.4(a), 6.5,
                    6.7, 7.2, 7.3, 9, 10, 11, 12, 13.4, 13.5, 13.6, 16 and 17)
                    shall remain in full force and effect.
                  </p>
                </div>
              </div>
            </div>

            {/* Clause 14 */}
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                14. CHANGES TO THESE TERMS
              </h3>

              <div className="space-y-4 text-gray-300">
                <p>
                  VuPop may vary these Terms from time to time. Any variations
                  will be brought to your attention. If you click “accept”,
                  “agree” or “ok” (or a similar term) to any amendments, or if
                  you continue to use the Services after we have notified you of
                  the amendments, you will be deemed to have accepted the
                  amendments.
                </p>
              </div>
            </div>

            {/* Clause 15 */}
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                15. FORCE MAJEURE
              </h3>

              <div className="space-y-6 text-gray-300">
                <div>
                  <p className="mb-4">
                    <strong>15.1</strong> Neither Party shall be liable to the other for any
                    delay or non-performance of its obligations under this
                    Agreement (other than an obligation to pay the Membership
                    Fees) arising from any cause or causes beyond its reasonable
                    control, including, but not limited to:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) any Services not being available due to mechanical
                      breakdown, maintenance, hardware or software upgrades,
                      telecommunication connectivity problems, outages from
                      cloud providers, power shortage, network failure, server
                      crashes, deletion, corruption, or loss or removal of data;
                    </li>
                    <li>
                      (b) either Party ceasing to have access to the internet
                      for any reason;
                    </li>
                    <li>
                      (c) any fire, explosion, storm, flood, tempest, drought,
                      earthquake, accident or pandemic;
                    </li>
                    <li>(d) war, hostilities, riots or acts of terrorism;</li>
                    <li>(e) failure of utility supply;</li>
                    <li>(f) failure of computer systems;</li>
                    <li>(g) labour dispute; or</li>
                    <li>
                      (h) any act or omission (including changes to laws or
                      regulations or any disapprovals or failures to approve) of
                      any government, government agency or authorised body (a
                      “Force Majeure Event”).
                    </li>
                  </ul>
                  <p className="mt-4">
                    The Party subject to a Force Majeure Event shall promptly
                    notify the other Party of that fact and will use its
                    reasonable endeavours to minimise the impact of such Force
                    Majeure Event.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>15.2</strong> If a Party is prevented from performing its obligations
                    under this Agreement by a Force Majeure Event which
                    continues for more than ninety (90) days, then either Party
                    will be entitled to terminate this Agreement on written
                    notice with immediate effect and without liability to the
                    other Party.
                  </p>
                </div>
              </div>
            </div>

            {/* Clause 16 */}
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">
                16. DISPUTES
              </h3>

              <div className="space-y-6 text-gray-300">
                <div>
                  <p className="mb-4">
                    <strong>16.1</strong> If a dispute arises out of, or in connection with, this
                    Agreement or the performance, validity or enforceability of
                    it (a “Dispute”) then except as expressly provided in this
                    Agreement, the Parties must follow the procedure set out in
                    this clause before commencing court proceedings:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) either Party shall give to the other, written notice
                      of the Dispute, setting out its nature and full
                      particulars (a “Dispute Notice”), together with relevant
                      supporting documents. On service of the Dispute Notice,
                      you and a VuPop representative shall attempt in good faith
                      to resolve the Dispute; and
                    </li>
                    <li>
                      (b) if the User and the VuPop representative are for any
                      reason unable to resolve the Dispute within fourteen (14)
                      days of service of the Dispute Notice, the Dispute shall
                      be referred to a senior management representative of VuPop
                      (and, in the case of a User that is an organisation, a
                      senior representative of that organisation), and the
                      Parties shall attempt in good faith to resolve the Dispute
                      for not less than fourteen (14) days.
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                   <strong>16.2</strong> The Parties agree that nothing in this Agreement shall
                    waive, preclude, or otherwise limit their rights to apply to
                    the Courts of England and Wales to: (i) pursue enforcement
                    of an arbitrator’s award; or (ii) seek injunctive or other
                    interim relief.
                  </p>
                </div>
              </div>
            </div>

            {/* Clause 17 */}
            <div className="border border-gray-700 rounded-b-lg p-6 mt-6">
              <h3 className="text-xl font-bold text-white mb-4">17. GENERAL</h3>

              <div className="space-y-6 text-gray-300">
                <div>
                  <p>
                    <strong>17.1</strong> The User shall not during the Term, nor for a period of
                    twelve (12) months following the termination or expiry of
                    this Agreement for any reason, on its own behalf or on
                    behalf of any third party, directly induce, or attempt to
                    induce, any person employed by VuPop who has been engaged in
                    the provision of the Services to the User to leave the
                    employment of VuPop or employ or engage in any capacity any
                    such employee, provided that this restriction shall not
                    apply to any such person who makes an unsolicited reply to a
                    bona fide public advertisement, including by the User on its
                    website, or solicitations conducted by an entity that is
                    acquired by or merged with the User, so long as such
                    solicitations were conducted prior to the date of such
                    acquisition or merger.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>17.2</strong> VuPop may at any time assign, mortgage, charge,
                    subcontract, delegate, declare a trust over or deal in any
                    other manner with any or all of its rights and obligations
                    under this Agreement.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>17.3</strong> You shall not assign, transfer, mortgage, charge,
                    subcontract, declare a trust over or deal in any other
                    manner with any of your rights and obligations under the
                    Agreement without the prior written consent of VuPop.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>17.4</strong> The Services are provided for the sole benefit of the
                    User, unless expressly agreed otherwise by the Parties and
                    set out in writing.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>17.5</strong> VuPop is an independent contractor to the User and
                    shall not be deemed to be a partner of, or otherwise
                    associated with, the User in any way.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>17.6</strong> This Agreement shall be governed by the laws of England
                    and Wales and shall (subject to Clause 16) be subject to the
                    exclusive jurisdiction of the Courts of England and Wales.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>17.7</strong> This Agreement constitutes the entire agreement between
                    the Parties relating to the matters provided for herein and
                    supersedes all previous agreements, understandings or
                    arrangements between the Parties relating to these matters.
                    Each of the Parties acknowledges and agrees that in entering
                    into this Agreement it does not rely on, and will have no
                    remedy in respect of, any statement, representation,
                    warranty or understanding (whether negligently or innocently
                    made) of any person (whether Party to the Agreement or not)
                    other than as expressly set out herein. Nothing in this
                    Clause shall limit or exclude any liability for fraud.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>17.8</strong> A waiver of any right or remedy is only effective if
                    given in writing. A delay or failure to exercise, or the
                    single or partial exercise of, any right or remedy shall not
                    waive that or any other right or remedy, nor shall it
                    prevent or restrict the further exercise of that or any
                    other right or remedy.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>17.9</strong> Except as expressly provided in this Agreement, the
                    rights and remedies provided under this Agreement are in
                    addition to, and not exclusive of, any rights or remedies
                    provided by law.
                  </p>
                </div>

                <div>
                  <p className="mb-4">
                    <strong>17.10</strong> Any notices to be given under this Agreement shall,
                    unless otherwise expressly stated, be in writing and shall
                    be given by sending the same by email. Notices shall be
                    delivered:
                  </p>
                  <ul className="ml-6 list-none space-y-2">
                    <li>
                      (a) if to the User, to the email address associated with
                      the User’s account; and
                    </li>
                    <li>
                      (b) if to VuPop, to{" "}
                      <a
                        onClick={(e) => {
                          e.preventDefault();
                          window.open(
                            "https://mail.google.com/mail/?view=cm&fs=1&to=contact@vupop.io",
                            "_blank"
                          );
                        }}
                        className="text-yellow-600 underline cursor-pointer"
                      >
                        contact@vupop.io
                      </a>{" "}
                      or such other email address as VuPop may notify to you in
                      writing from time to time during the Term.
                    </li>
                  </ul>
                </div>

                <div>
                  <p>
                    <strong>17.11</strong> Any notice by email shall be deemed to have been
                    delivered on the same day (if sent during Normal Business
                    Hours), and if sent outside of Normal Business Hours, at 9am
                    on the next Business Day. Clauses 17.10 and 17.11 do not
                    apply to the service of any proceedings or other documents
                    in any legal action or, where applicable, any other method
                    of dispute resolution.
                  </p>
                </div>

                <div>
                  <p>
                   <strong>17.12</strong> A person who is not a party to this Agreement shall
                    have no rights under the Contracts (Rights of Third Parties)
                    Act 1999 to enforce any of its terms.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>17.13</strong> This Agreement may be executed in any number of
                    counterparts, each of which when executed shall constitute a
                    duplicate original, but all the counterparts shall together
                    constitute the one agreement.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>17.14</strong> The invalidity or unenforceability of any provision,
                    part-provision or any right arising under this Agreement
                    shall not affect the validity or enforceability of any other
                    provisions or rights. If any provision or part-provision is
                    adjudged to be invalid or unenforceable, the relevant
                    provisions shall apply with such deletions or modifications
                    as may be necessary to make them valid and effective.
                  </p>
                </div>

                <div>
                  <p>
                    <strong>17.15</strong> If any provision or part-provision of this Agreement
                    is deemed deleted under Clause 17.14, the parties shall
                    negotiate in good faith to agree a replacement provision
                    that, to the greatest extent possible, achieves the intended
                    commercial result of the original provision.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="mt-8 pt-6 border-t border-gray-700 text-center text-yellow-400">
            <p>Last updated: 9 October 2025</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppTerms;
